interface SetCookieOptions {
  name: string;
  value: string;
  days?: number;
  domain?: string | null;
}

export const setCookie = ({
  name,
  value,
  days = 1,
  domain,
}: SetCookieOptions) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;

  const domainPart =
    domain === null ? '' : `;domain=${domain || getRootDomain()}`;
  document.cookie = `${name}=${value};${expires}${domainPart};path=/`;
};

export const getCookie = (name: string): string | object | null => {
  if (typeof window === 'undefined') return null;

  const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
    const [key, value] = cookie.split('=');
    acc[key] = decodeURIComponent(value);
    return acc;
  }, {} as Record<string, string>);

  const cookieValue = cookies[name];
  if (!cookieValue) {
    return null;
  }

  try {
    return JSON.parse(cookieValue);
  } catch {
    return cookieValue;
  }
};

export const getRootDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};
